import { useCallback } from "react";
import { Mail } from "lucide-react";
import { useEmailSignatureTable } from "hooks/useEmailSignatureTable";
import EmailSignatureService from "services/EmailSignatures";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { TableCreateButton } from "components/BaseTableV3/TableCreateButton";
import { getNextQueryParams } from "components/helpers";
import useAuthorized from "hooks/useAuthorized";
import ACL_RELATIONSHIPS from "acl-relationships";
import { invalidateEmailSignatureTableQuery } from "hooks/useEmailSignatureTable";

export const EMAIL_SIGNATURE_TABLE_CONSTANTS = {
  tableName: "email_signatures",
  queryKey: "email_signature",
  className: "EmailSignature",
  header: "Email Signatures",
  headerIcon: Mail,
};

const EmailSignatureTableV3 = () => {
  const enableTags = useAuthorized(
    [
      ACL_RELATIONSHIPS.emailSignaturesTags.create,
      ACL_RELATIONSHIPS.emailSignaturesTags.read,
      ACL_RELATIONSHIPS.emailSignaturesTags.delete,
    ],
    { partialMatch: true }
  );
  const { filters, columns } = useEmailSignatureTable({
    className: EMAIL_SIGNATURE_TABLE_CONSTANTS.className,
    tableName: EMAIL_SIGNATURE_TABLE_CONSTANTS.tableName,
  });

  const fetchData = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await EmailSignatureService.getEmailSignatures(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching email signatures:", error);
        throw error;
      }
    },
    [columns]
  );

  const createButton = (
    <TableCreateButton
      permissions={[ACL_RELATIONSHIPS.emailSignatures.create]}
      to="/settings/email_signatures/new"
    >
      New Signature Template
    </TableCreateButton>
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      tagsDropdownParams={{ visible: enableTags }}
      queryKey={EMAIL_SIGNATURE_TABLE_CONSTANTS.queryKey}
      className={EMAIL_SIGNATURE_TABLE_CONSTANTS.className}
      tableName={EMAIL_SIGNATURE_TABLE_CONSTANTS.tableName}
      headerIcon={EMAIL_SIGNATURE_TABLE_CONSTANTS.headerIcon}
      header={EMAIL_SIGNATURE_TABLE_CONSTANTS.header}
      enableSearch
      enableSettings
      fetchData={fetchData}
      createButton={createButton}
      invalidateData={invalidateEmailSignatureTableQuery}
    />
  );
};

export default EmailSignatureTableV3;
